import { common } from '@material-ui/core/colors';

export const palette = {
  text: {
    primary: common.black,
    secondary: '#4F4F55',
    tertiary: '#3C3C4399',
  },
  border: {
    primary: '#3c3c4421',
    secondary: '#3c3c434a',
    tertiary: common.black,
  },
  background: {
    primary: common.white,
    secondary: '#efeff4',
    tertiary: '#dbdbdb',
    quaternary: '#fafafa',
  },
  fill: {
    primary: '#74748014',
    secondary: '#7878801f',
    tertiary: '#78788029',
  },
  uiPrimary: {
    primary: '#5565FD',
    secondary: '#6F7FFF',
    tertiary: '#3C4CE4',
    quaternary: '#A2B2FF',
  },
  ui: {
    primary: {
      // UI Purple
      main: '#5565FD',
      5: '#F7F7FF',
      10: '#E7E8FF',
      20: '#BEC2FE',
      30: '#9EA3FE',
      40: '#7882FD',
      50: '#5364FD',
      60: '#2A48FC',
      70: '#062EC9',
      80: '#031E90',
      90: '#010840',
    },
    pink: {
      // UI Pink
      main: '#FF3B30',
      5: '#FFF6F6',
      10: '#FFE3E3',
      20: '#FFB3B2',
      30: '#FF8986',
      40: '#FF4D46',
      50: '#E81C00',
      60: '#C31600',
      70: '#900D00',
      80: '#660600',
      90: '#2C0100',
    },
    purple: {
      // UI Purple
      main: '#A35DD7',
      5: '#FAF7FD',
      10: '#EFE6F9',
      20: '#D5BDEF',
      30: '#C29BE7',
      40: '#AE75DE',
      50: '#9E52D4',
      60: '#8641B6',
      70: '#622D86',
      80: '#451E5F',
      90: '#1B0828',
    },
    blue: {
      // UI Blue
      main: '#2E7DF7',
      5: '#F6F8FF',
      10: '#E4E9FE',
      20: '#B4C5FC',
      30: '#8BA9FA',
      40: '#548BF8',
      50: '#2272E5',
      60: '#1B5FC1',
      70: '#11448E',
      80: '#092E65',
      90: '#02102B',
    },
    teal: {
      // UI Teal
      main: '#008FB2',
      5: '#F0F9FF',
      10: '#CFEEFF',
      20: '#5DD4FF',
      30: '#00BAE6',
      40: '#009AC0',
      50: '#0080A0',
      60: '#006B86',
      70: '#004D62',
      80: '#003544',
      90: '#00131B',
    },
    green: {
      // UI Green
      main: '#469F3D',
      5: '#E9FEE7',
      10: '#B4FBAF',
      20: '#65E059',
      30: '#57C14C',
      40: '#47A13E',
      50: '#3A8532',
      60: '#2F6F28',
      70: '#20511B',
      80: '#143810',
      90: '#041503',
    },
    orange: {
      // UI Orange
      main: '#FF9800',
      5: '#FFF6F4',
      10: '#FEE4DF',
      20: '#FDB5A5',
      30: '#FC8D6A',
      40: '#EA651D',
      50: '#C45316',
      60: '#A44511',
      70: '#793109',
      80: '#552004',
      90: '#230901',
    },
    red: {
      // UI Red
      main: '#EE586B',
      5: '#FEF6F7',
      10: '#FBE4E6',
      20: '#F5B7BB',
      30: '#F18F98',
      40: '#EE5C6E',
      50: '#DA354F',
      60: '#B72B41',
      70: '#871D2E',
      80: '#60111E',
      90: '#280408',
    },
  },
};
